import React, { useMemo, useState } from "react"
import API from "../../utils/API"
import truncate from "../../utils/Truncate"
import Sweetalert from "../../utils/Sweetalert"
import ButtonEdit from "../ButtonEdit"
import InputEdit from "../InputEdit"
import moment from "moment"
import { openSchedulerModal } from "./Scheduler/SchedulerModal"

export default function DiffusionTotemCardAd({ ad, maxDuration, deselectAd, updateAd }) {
  // State
  const [newValue, setNewValue] = useState(null)
  const [editGranularity, setEditGranularity] = useState(false)
  const [editDuration, setEditDuration] = useState(false)

  // Comportements
  const isPlanificationActive = useMemo(() => {
    // Vérifie si la planification est active
    // On considère qu'elle est active si la date de fin est dans le passé (en ajoutant un jour pour inclure le jour de fin)
    return ad.totem_ad.planification && moment(ad.totem_ad.planification.endDate).add(1, "day").isAfter(moment())
  })

  const cancelEdit = () => {
    setEditGranularity(false)
    setEditDuration(false)
  }

  const handleEdit = (field) => {
    if (field === "duration") {
      cancelEdit()
      setNewValue(ad.totem_ad.notVideoDuration)
      setEditDuration(true)
    } else {
      cancelEdit()
      setNewValue(ad.totem_ad.granularity)
      setEditGranularity(true)
    }
  }

  const handlePlanificationEdit = async () => {
    const planification = await openSchedulerModal(ad.totem_ad.planification)

    if (planification !== false) {
      API.PUT(
        "/totem/" + ad.totem_ad.totemId + "/ad/" + ad.id,
        {
          granularity: ad.totem_ad.granularity,
          notVideoDuration: ad.totem_ad.notVideoDuration,
          planification,
        },
        (response) => {
          Sweetalert.fireSuccessToast(response.data.message)
          updateAd(ad.id, ad.totem_ad.granularity, ad.totem_ad.notVideoDuration, planification)
        }
      )
    }
  }

  const handleEditSubmit = (field) => {
    let newNVDuration = ad.totem_ad.notVideoDuration
    let newGranularity = ad.totem_ad.granularity
    if (field === "duration") {
      newNVDuration = newValue
    } else {
      newGranularity = newValue
    }
    if (ad.duration + newNVDuration > maxDuration) {
      Sweetalert.fireWarningToast(
        "Vous dépassez la limite de " + maxDuration + "s de diffusion par boucle autorisée pour ce totem"
      )
      cancelEdit()
    } else {
      API.PUT(
        "/totem/" + ad.totem_ad.totemId + "/ad/" + ad.id,
        {
          granularity: newGranularity,
          notVideoDuration: newNVDuration,
        },
        (response) => {
          Sweetalert.fireSuccessToast(response.data.message)
          updateAd(ad.id, newGranularity, parseInt(newNVDuration))
          cancelEdit()
        }
      )
    }
  }

  // Rendu
  return (
    <tr>
      <td>{truncate(ad.name, 30)}</td>
      <td>
        {editDuration ? (
          <InputEdit
            type="number"
            min="1"
            max={maxDuration - ad.duration}
            value={newValue}
            onChange={(event) => setNewValue(event.target.value)}
            onSubmit={() => handleEditSubmit("duration")}
            onCancel={() => setEditDuration(false)}
          />
        ) : (
          <>
            {ad.duration + ad.totem_ad.notVideoDuration} s{" "}
            {ad.totem_ad.notVideoDuration > 0 && <ButtonEdit onClick={() => handleEdit("duration")} />}
          </>
        )}
      </td>
      <td>
        {editGranularity ? (
          <InputEdit
            type="number"
            min="1"
            value={newValue}
            onChange={(event) => setNewValue(event.target.value)}
            onSubmit={() => handleEditSubmit("granularity")}
            onCancel={() => setEditGranularity(false)}
          />
        ) : (
          <>
            {ad.totem_ad.granularity} x
            <ButtonEdit onClick={() => handleEdit("granularity")} />
          </>
        )}
      </td>
      <td>
        {ad.totem_ad.planification ? (
          isPlanificationActive ? (
            <i className="far fa-calendar-check" title="Planification active" style={{ color: "green" }}></i>
          ) : (
            <i
              className="far fa-calendar-times"
              title="Planification inactive, la ressource n'est plus diffusée"
              style={{ color: "red" }}
            ></i>
          )
        ) : (
          "Non"
        )}{" "}
        <ButtonEdit onClick={() => handlePlanificationEdit()} />
      </td>
      <td className="project-actions text-right">
        <button className="btn btn-danger btn-xs" onClick={() => deselectAd(ad.id)}>
          <i className="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  )
}
